<template>
  <div class="notfound-container d-flex flex-column h-100">
    <section class="col-md-6 container">
      <div class="form-upgrade card">
        <div class="row">
          <div class="col-md-12">
            <div class="upgrade-heading">
              <h5 class="py-3 text-green">UPGRADE SUBSCRIPTION PACKAGE</h5>
            </div>
            <div class="py-2 bg-grey200">
              <div class="upgrade-plan py-3">
                <p>CURRENT PLAN: Basic</p>
                <p>
                  Watch on 2 screens at a time. Download videos on 2 devices for
                  a month
                </p>
                <p>₦2000 / Month</p>
              </div>
              <div class="upgrade-plan py-2">
                <p>New PLAN: Premium (Monthly)</p>
                <p>
                  Watch on 5 screens at a time. Download videos on 5 devices for
                  a month.
                </p>
                <p>You will be charged ₦1,000 immediately</p>
              </div>
            </div>
            <div class="upgrade-plan py-3">
              <div class="buttons">
                <a href="/#/" class="btn btn-primary btn-lg">
                {{ getText("confirm_change_button_text") }}
                </a>
                <a href="/#/" class="btn btn-light btn-lg ml-2">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "Subscription1",
  components: {},
  methods:{
    getText(val) {
      		return this.$store.getters.getGlobalConfigs[val];
    	},
  }
};
</script>

<style scoped>
.container {
  align-items: center;
  padding-top: 10%;
}
.card {
  border-radius: 20px;
}
.buttons {
  padding-left: 18%;
  padding-bottom: 20px;
  padding-top: 30px;
}
.upgrade-plan {
  padding-left: 30px;
}

.upgrade-plan > p {
  padding-top: 0px;
  padding-bottom: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.upgrade-heading {
  padding-left: 50px;
  padding-top: 30px;
}
</style>
